import React, { useRef, useState } from "react";

import styles from "./changePassword.module.css";

import { Password } from "primereact/password";
import { Button } from "primereact/button";

import { Form, Formik } from "formik";

import CustomToast from "components/ui/Toast";

import { ChangePasswordSchema } from "config/validationSchema";
import { useAuth } from "context/AuthContext";
import { API } from "middleware/api";

const ChangePassword = () => {
  const toast = useRef(null);
  const [toastOptions, setToastOptions] = useState();
  const { userDetails, removeToken, loginType } = useAuth();

  const handleChangePassword = async (values, setSubmitting) => {
    try {
      let response;

      if (["nagar_nigam", "jalkal"].includes(loginType)) {
        response = await API.changeOfficialsPassword({
          email: userDetails?.email,
          oldPassword: values.oldPassword,
          newPassword: values.newPassword,
        });
      } else {
        response = await API.changeUploadUserPassword({
          email: userDetails?.email,
          oldPassword: values.oldPassword,
          newPassword: values.newPassword,
        });
      }

      if (response) {
        setToastOptions({
          severity: "success",
          summary: "Success",
          detail: "Password changed successfully, please login",
        });
        removeToken();
      } else {
        setToastOptions({
          severity: "error",
          summary: "Error",
          detail: "Employee not found",
        });
      }
    } catch (error) {
      setToastOptions({
        severity: "error",
        summary: "Error",
        detail: error.message,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <CustomToast ref={toast} toastOptions={toastOptions} />

      <Formik
        initialValues={{
          email: userDetails?.email,
          oldPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        }}
        validationSchema={ChangePasswordSchema}
        validateOnBlur
        onSubmit={(values, { setSubmitting }) => {
          handleChangePassword(values, setSubmitting);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="password">
                <b>Old Password</b>
              </label>
              <Password
                id="oldPassword"
                name="oldPassword"
                className={`${
                  errors.oldPassword && touched.oldPassword
                    ? "p-invalid w-full"
                    : "w-full"
                }`}
                inputClassName="w-full"
                toggleMask
                feedback={false}
                value={values.oldPassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <small className={styles.error}>
                {errors.oldPassword &&
                  touched.oldPassword &&
                  errors.oldPassword}
              </small>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="password">
                <b>New Password</b>
              </label>
              <Password
                id="newPassword"
                name="newPassword"
                className={`${
                  errors.newPassword && touched.newPassword
                    ? "p-invalid w-full"
                    : "w-full"
                }`}
                inputClassName="w-full"
                toggleMask
                feedback={false}
                value={values.newPassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <small className={styles.error}>
                {errors.newPassword &&
                  touched.newPassword &&
                  errors.newPassword}
              </small>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="confirmNewPassword">
                <b>Confirm New Password</b>
              </label>
              <Password
                id="confirmNewPassword"
                name="confirmNewPassword"
                className={`${
                  errors.confirmNewPassword && touched.confirmNewPassword
                    ? "p-invalid w-full"
                    : "w-full"
                }`}
                inputClassName="w-full"
                toggleMask
                feedback={false}
                value={values.confirmNewPassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <small className={styles.error}>
                {errors.confirmNewPassword &&
                  touched.confirmNewPassword &&
                  errors.confirmNewPassword}
              </small>
            </div>

            <Button
              type="submit"
              label="Change Credentials"
              icon="pi pi-lock"
              iconPos="left"
              loading={isSubmitting}
              disabled={isSubmitting || Object.keys(errors).length > 0}
              onClick={() => {
                handleSubmit();
              }}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ChangePassword;
